var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#77C002",
    fillOpacity: 0.095
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lock_svg__clip0_1185_14881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.858 4.027c9.346.005 17.01 7.355 17.512 16.573.019.325.028 4.959.028 5.287h-7.363v-4.308c.003-5.614-4.565-10.186-10.18-10.189-5.616-.003-10.181 4.566-10.184 10.18l-.008 26.87-7.366-.003.01-26.87c.006-9.674 7.877-17.544 17.55-17.54z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.302 26.986l-.009 21.45h7.366l.008-26.866-7.365 5.416z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.499 36.133l-.018 42.86c0 .54-.441.982-.981.982l-47.019-.019a.984.984 0 01-.981-.981l.017-42.86c0-.545.442-.982.982-.982l47.018.02a.977.977 0 01.982.98z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 35.151l-.02 43.842c0 .54-.44.981-.98.981l-10.676-.004.019-44.823 11.657.004z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.493 49.559l-.012 29.436c0 .54-.442.98-.981.98l-10.676-.004.008-18.249L66.493 49.56zM54.832 58.798l11.661-11.274.002-3.473-11.661 10.736-.002 4.011zM41.725 66.657l-10.965-.004a.494.494 0 01-.462-.659l2.019-5.614.944-2.62a5.674 5.674 0 01-2.634-4.802v-.043a5.682 5.682 0 017.154-5.446 5.773 5.773 0 011.825.86 5.675 5.675 0 012.39 4.636 5.686 5.686 0 01-2.438 4.666l2.632 8.39a.49.49 0 01-.465.636z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.82 79.233a.234.234 0 01-.234-.234l.016-38.802a.234.234 0 11.468 0L55.054 79a.233.233 0 01-.234.232z",
    fill: "#1D232A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__clip0_1185_14881"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.5 4.027)",
    d: "M0 0h49v75.947H0z"
  })))));
}
export default SvgLock;